export const NOTIFICATION_LIMIT = 20
export const currentAppVersion = 1.01
export const REPO_URL = 'https://github.com/ayush1920/json2xml'
export const FILE_SIZE_LIMIT = 1048576;